/**
 * The one `ApiClient` instance for the staff app.
 *
 * Note the session namespace: `'staff'`. The portal builds its own store with its own
 * namespace, which is what stops the two apps ever seeing each other's credentials.
 * There is no shared default to fall into.
 */

import { API_ROOTS, ApiClient, createSessionStore, refreshSession } from '@legalcrm/api';

export const sessionStore = createSessionStore('staff');

/** Set by `AuthProvider` so a dead session routes the app to login. */
let onSessionEnded: (() => void) | null = null;

export function setSessionEndedHandler(handler: (() => void) | null): void {
  onSessionEnded = handler;
}

// Explicitly annotated: `refresh` refers to `apiClient` from inside its own
// initializer, and without the annotation TypeScript cannot break the cycle.
export const apiClient: ApiClient = new ApiClient({
  // Router resources hang off this root. The registered auth paths (login, me,
  // refresh, logout) are absolute and bypass it — see `EXACT_PATHS`.
  baseUrl: API_ROOTS.staff,
  session: sessionStore,
  refresh: (current) => refreshSession(apiClient, current),
  onUnauthenticated: () => onSessionEnded?.(),
});
